import * as React from "react";
import { styled } from "@mui/material/styles";
import { lighten } from "@mui/system";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { useSettings } from "conference/components/meeting-page/tools";
import { defineMessage, FormattedMessage, MessageDescriptor } from "react-intl";

const OptionContainer = styled("div", {
    shouldForwardProp: (prop) => prop !== "selected",
})<{ selected?: boolean }>(({ theme }) => ({
    padding: "0.5em 1em",
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    transition: "background-color 0.2s",
    backgroundColor: undefined,
    "&:hover": {
        backgroundColor: lighten(theme.palette.background.paper, 0.2),
    },
    variants: [
        {
            props: ({ selected }) => selected,
            style: {
                backgroundColor: lighten(theme.palette.background.paper, 0.4),
            },
        },
    ],
}));

const FigureContainer = styled("div")(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    marginRight: "1em",
    display: "flex",
    alignItems: "center",
}));

type Props = {
    label: MessageDescriptor;
    children: React.ReactNode;
    selected: boolean;
    onClick: () => void;
};

export const EffectOption = ({ label, children, onClick, selected }: Props) => {
    return (
        <OptionContainer selected={selected} onClick={onClick}>
            <FigureContainer>{children}</FigureContainer>
            <div>
                <FormattedMessage {...label} />
            </div>
        </OptionContainer>
    );
};

export const NoneOption = () => {
    const settings = useSettings();

    const select = () => {
        settings.videoBackgroundEffect = { type: "none" };
    };

    return (
        <EffectOption
            label={defineMessage({ id: "videoBackgroundEffect.none", defaultMessage: "None" })}
            onClick={select}
            selected={settings.videoBackgroundEffect.type === "none"}
        >
            <HighlightOffIcon fontSize="large" />
        </EffectOption>
    );
};
